export const en = {
  shared: {
    chooseImage: 'Choose image',
    loadingData: 'Loading data, please wait...',
    errorLoadingData: 'Failed to load data! Description of an error:',
    retry: 'Retry'
  }
};
